export default {
	"total": [{
		"value": "40037",
		"name": "北京"
	}, {
		"value": "228336",
		"name": "天津"
	}, {
		"value": "1310196",
		"name": "河北"
	}, {
		"value": "350776",
		"name": "山西"
	}, {
		"value": "699614",
		"name": "河南"
	}, {
		"value": "728946",
		"name": "山东"
	}, {
		"value": "41522",
		"name": "上海"
	}, {
		"value": "515175",
		"name": "江苏"
	}, {
		"value": "229469",
		"name": "浙江"
	}, {
		"value": "118275",
		"name": "福建"
	}, {
		"value": "309012",
		"name": "安徽"
	}, {
		"value": "119066",
		"name": "江西"
	}, {
		"value": "471663",
		"name": "湖北"
	}, {
		"value": "511760",
		"name": "湖南"
	}, {
		"value": "531354",
		"name": "广东"
	}, {
		"value": "333802",
		"name": "广西"
	}, {
		"value": "203034",
		"name": "贵州"
	}, {
		"value": "359422",
		"name": "云南"
	}, {
		"value": "25751",
		"name": "海南"
	}, {
		"value": "187595",
		"name": "黑龙江"
	}, {
		"value": "539015",
		"name": "吉林"
	}, {
		"value": "932949",
		"name": "辽宁"
	}, {
		"value": "845792",
		"name": "陕西"
	}, {
		"value": "741232",
		"name": "新疆"
	}, {
		"value": "922596",
		"name": "内蒙古"
	}, {
		"value": "238724",
		"name": "青海"
	}, {
		"value": "366878",
		"name": "宁夏"
	}, {
		"value": "781770",
		"name": "甘肃"
	}, {
		"value": "51680",
		"name": "西藏"
	}, {
		"value": "1000320",
		"name": "四川"
	}, {
		"value": "301604",
		"name": "重庆"
	}],
	"list": [{
		"item": [{
			"value": "-1",
			"name": "北京"
		}, {
			"value": "29802",
			"name": "天津"
		}, {
			"value": "78627",
			"name": "河北"
		}, {
			"value": "2196",
			"name": "山西"
		}, {
			"value": "7312",
			"name": "河南"
		}, {
			"value": "9604",
			"name": "山东"
		}, {
			"value": "666",
			"name": "上海"
		}, {
			"value": "2158",
			"name": "江苏"
		}, {
			"value": "618",
			"name": "浙江"
		}, {
			"value": "371",
			"name": "福建"
		}, {
			"value": "906",
			"name": "安徽"
		}, {
			"value": "159",
			"name": "江西"
		}, {
			"value": "5352",
			"name": "湖北"
		}, {
			"value": "3043",
			"name": "湖南"
		}, {
			"value": "1920",
			"name": "广东"
		}, {
			"value": "1248",
			"name": "广西"
		}, {
			"value": "801",
			"name": "贵州"
		}, {
			"value": "607",
			"name": "云南"
		}, {
			"value": "737",
			"name": "海南"
		}, {
			"value": "1436",
			"name": "黑龙江"
		}, {
			"value": "2662",
			"name": "吉林"
		}, {
			"value": "17620",
			"name": "辽宁"
		}, {
			"value": "4945",
			"name": "陕西"
		}, {
			"value": "2144",
			"name": "新疆"
		}, {
			"value": "13223",
			"name": "内蒙古"
		}, {
			"value": "419",
			"name": "青海"
		}, {
			"value": "1509",
			"name": "宁夏"
		}, {
			"value": "3688",
			"name": "甘肃"
		}, {
			"value": "58",
			"name": "西藏"
		}, {
			"value": "3801",
			"name": "四川"
		}, {
			"value": "1935",
			"name": "重庆"
		}],
		"nameName": "北京",
		"toatl": "199567"
	}, {
		"item": [{
			"value": "2729",
			"name": "北京"
		}, {
			"value": "-1",
			"name": "天津"
		}, {
			"value": "69103",
			"name": "河北"
		}, {
			"value": "3029",
			"name": "山西"
		}, {
			"value": "6491",
			"name": "河南"
		}, {
			"value": "10500",
			"name": "山东"
		}, {
			"value": "394",
			"name": "上海"
		}, {
			"value": "2856",
			"name": "江苏"
		}, {
			"value": "473",
			"name": "浙江"
		}, {
			"value": "142",
			"name": "福建"
		}, {
			"value": "856",
			"name": "安徽"
		}, {
			"value": "133",
			"name": "江西"
		}, {
			"value": "1871",
			"name": "湖北"
		}, {
			"value": "1124",
			"name": "湖南"
		}, {
			"value": "931",
			"name": "广东"
		}, {
			"value": "525",
			"name": "广西"
		}, {
			"value": "220",
			"name": "贵州"
		}, {
			"value": "617",
			"name": "云南"
		}, {
			"value": "94",
			"name": "海南"
		}, {
			"value": "1076",
			"name": "黑龙江"
		}, {
			"value": "3173",
			"name": "吉林"
		}, {
			"value": "16529",
			"name": "辽宁"
		}, {
			"value": "4890",
			"name": "陕西"
		}, {
			"value": "7354",
			"name": "新疆"
		}, {
			"value": "24906",
			"name": "内蒙古"
		}, {
			"value": "961",
			"name": "青海"
		}, {
			"value": "3852",
			"name": "宁夏"
		}, {
			"value": "2927",
			"name": "甘肃"
		}, {
			"value": "102",
			"name": "西藏"
		}, {
			"value": "2968",
			"name": "四川"
		}, {
			"value": "745",
			"name": "重庆"
		}],
		"nameName": "天津",
		"toatl": "171571"
	}, {
		"item": [{
			"value": "20260",
			"name": "北京"
		}, {
			"value": "102492",
			"name": "天津"
		}, {
			"value": "-1",
			"name": "河北"
		}, {
			"value": "152832",
			"name": "山西"
		}, {
			"value": "147147",
			"name": "河南"
		}, {
			"value": "270902",
			"name": "山东"
		}, {
			"value": "1393",
			"name": "上海"
		}, {
			"value": "48784",
			"name": "江苏"
		}, {
			"value": "6671",
			"name": "浙江"
		}, {
			"value": "6186",
			"name": "福建"
		}, {
			"value": "18828",
			"name": "安徽"
		}, {
			"value": "5462",
			"name": "江西"
		}, {
			"value": "37003",
			"name": "湖北"
		}, {
			"value": "42460",
			"name": "湖南"
		}, {
			"value": "9980",
			"name": "广东"
		}, {
			"value": "19920",
			"name": "广西"
		}, {
			"value": "6828",
			"name": "贵州"
		}, {
			"value": "18524",
			"name": "云南"
		}, {
			"value": "934",
			"name": "海南"
		}, {
			"value": "18580",
			"name": "黑龙江"
		}, {
			"value": "26264",
			"name": "吉林"
		}, {
			"value": "115736",
			"name": "辽宁"
		}, {
			"value": "97817",
			"name": "陕西"
		}, {
			"value": "150526",
			"name": "新疆"
		}, {
			"value": "220334",
			"name": "内蒙古"
		}, {
			"value": "33082",
			"name": "青海"
		}, {
			"value": "65518",
			"name": "宁夏"
		}, {
			"value": "72062",
			"name": "甘肃"
		}, {
			"value": "3145",
			"name": "西藏"
		}, {
			"value": "78810",
			"name": "四川"
		}, {
			"value": "12145",
			"name": "重庆"
		}],
		"nameName": "河北",
		"toatl": "1810625"
	}, {
		"item": [{
			"value": "1674",
			"name": "北京"
		}, {
			"value": "7855",
			"name": "天津"
		}, {
			"value": "181095",
			"name": "河北"
		}, {
			"value": "-1",
			"name": "山西"
		}, {
			"value": "57453",
			"name": "河南"
		}, {
			"value": "26598",
			"name": "山东"
		}, {
			"value": "143",
			"name": "上海"
		}, {
			"value": "6191",
			"name": "江苏"
		}, {
			"value": "1154",
			"name": "浙江"
		}, {
			"value": "1955",
			"name": "福建"
		}, {
			"value": "4671",
			"name": "安徽"
		}, {
			"value": "1774",
			"name": "江西"
		}, {
			"value": "13650",
			"name": "湖北"
		}, {
			"value": "12222",
			"name": "湖南"
		}, {
			"value": "6195",
			"name": "广东"
		}, {
			"value": "10967",
			"name": "广西"
		}, {
			"value": "5457",
			"name": "贵州"
		}, {
			"value": "9318",
			"name": "云南"
		}, {
			"value": "317",
			"name": "海南"
		}, {
			"value": "2557",
			"name": "黑龙江"
		}, {
			"value": "2689",
			"name": "吉林"
		}, {
			"value": "7846",
			"name": "辽宁"
		}, {
			"value": "130640",
			"name": "陕西"
		}, {
			"value": "24392",
			"name": "新疆"
		}, {
			"value": "109028",
			"name": "内蒙古"
		}, {
			"value": "7357",
			"name": "青海"
		}, {
			"value": "19080",
			"name": "宁夏"
		}, {
			"value": "31337",
			"name": "甘肃"
		}, {
			"value": "609",
			"name": "西藏"
		}, {
			"value": "53057",
			"name": "四川"
		}, {
			"value": "8574",
			"name": "重庆"
		}],
		"nameName": "山西",
		"toatl": "745855"
	}, {
		"item": [{
			"value": "2202",
			"name": "北京"
		}, {
			"value": "5346",
			"name": "天津"
		}, {
			"value": "78493",
			"name": "河北"
		}, {
			"value": "72061",
			"name": "山西"
		}, {
			"value": "-1",
			"name": "河南"
		}, {
			"value": "84855",
			"name": "山东"
		}, {
			"value": "4889",
			"name": "上海"
		}, {
			"value": "36636",
			"name": "江苏"
		}, {
			"value": "22923",
			"name": "浙江"
		}, {
			"value": "16102",
			"name": "福建"
		}, {
			"value": "71258",
			"name": "安徽"
		}, {
			"value": "15439",
			"name": "江西"
		}, {
			"value": "116109",
			"name": "湖北"
		}, {
			"value": "89734",
			"name": "湖南"
		}, {
			"value": "47672",
			"name": "广东"
		}, {
			"value": "48280",
			"name": "广西"
		}, {
			"value": "12818",
			"name": "贵州"
		}, {
			"value": "38490",
			"name": "云南"
		}, {
			"value": "2694",
			"name": "海南"
		}, {
			"value": "2677",
			"name": "黑龙江"
		}, {
			"value": "2864",
			"name": "吉林"
		}, {
			"value": "17073",
			"name": "辽宁"
		}, {
			"value": "172804",
			"name": "陕西"
		}, {
			"value": "137578",
			"name": "新疆"
		}, {
			"value": "20317",
			"name": "内蒙古"
		}, {
			"value": "28122",
			"name": "青海"
		}, {
			"value": "55301",
			"name": "宁夏"
		}, {
			"value": "118326",
			"name": "甘肃"
		}, {
			"value": "8128",
			"name": "西藏"
		}, {
			"value": "97445",
			"name": "四川"
		}, {
			"value": "19396",
			"name": "重庆"
		}],
		"nameName": "河南",
		"toatl": "1446032"
	}, {
		"item": [{
			"value": "2765",
			"name": "北京"
		}, {
			"value": "18851",
			"name": "天津"
		}, {
			"value": "132954",
			"name": "河北"
		}, {
			"value": "34904",
			"name": "山西"
		}, {
			"value": "132928",
			"name": "河南"
		}, {
			"value": "-1",
			"name": "山东"
		}, {
			"value": "4259",
			"name": "上海"
		}, {
			"value": "138839",
			"name": "江苏"
		}, {
			"value": "17733",
			"name": "浙江"
		}, {
			"value": "8207",
			"name": "福建"
		}, {
			"value": "55646",
			"name": "安徽"
		}, {
			"value": "14051",
			"name": "江西"
		}, {
			"value": "41303",
			"name": "湖北"
		}, {
			"value": "39337",
			"name": "湖南"
		}, {
			"value": "20588",
			"name": "广东"
		}, {
			"value": "36316",
			"name": "广西"
		}, {
			"value": "8358",
			"name": "贵州"
		}, {
			"value": "20622",
			"name": "云南"
		}, {
			"value": "1744",
			"name": "海南"
		}, {
			"value": "9585",
			"name": "黑龙江"
		}, {
			"value": "13626",
			"name": "吉林"
		}, {
			"value": "58047",
			"name": "辽宁"
		}, {
			"value": "68075",
			"name": "陕西"
		}, {
			"value": "100918",
			"name": "新疆"
		}, {
			"value": "44312",
			"name": "内蒙古"
		}, {
			"value": "19455",
			"name": "青海"
		}, {
			"value": "32377",
			"name": "宁夏"
		}, {
			"value": "60738",
			"name": "甘肃"
		}, {
			"value": "2290",
			"name": "西藏"
		}, {
			"value": "70189",
			"name": "四川"
		}, {
			"value": "10165",
			"name": "重庆"
		}],
		"nameName": "山东",
		"toatl": "1219182"
	}, {
		"item": [{
			"value": "556",
			"name": "北京"
		}, {
			"value": "1556",
			"name": "天津"
		}, {
			"value": "11496",
			"name": "河北"
		}, {
			"value": "1272",
			"name": "山西"
		}, {
			"value": "14651",
			"name": "河南"
		}, {
			"value": "18797",
			"name": "山东"
		}, {
			"value": "-1",
			"name": "上海"
		}, {
			"value": "95832",
			"name": "江苏"
		}, {
			"value": "37039",
			"name": "浙江"
		}, {
			"value": "2972",
			"name": "福建"
		}, {
			"value": "19575",
			"name": "安徽"
		}, {
			"value": "3313",
			"name": "江西"
		}, {
			"value": "14825",
			"name": "湖北"
		}, {
			"value": "9025",
			"name": "湖南"
		}, {
			"value": "12274",
			"name": "广东"
		}, {
			"value": "3734",
			"name": "广西"
		}, {
			"value": "2252",
			"name": "贵州"
		}, {
			"value": "3459",
			"name": "云南"
		}, {
			"value": "465",
			"name": "海南"
		}, {
			"value": "2555",
			"name": "黑龙江"
		}, {
			"value": "3739",
			"name": "吉林"
		}, {
			"value": "18682",
			"name": "辽宁"
		}, {
			"value": "11153",
			"name": "陕西"
		}, {
			"value": "4983",
			"name": "新疆"
		}, {
			"value": "1510",
			"name": "内蒙古"
		}, {
			"value": "395",
			"name": "青海"
		}, {
			"value": "2411",
			"name": "宁夏"
		}, {
			"value": "7222",
			"name": "甘肃"
		}, {
			"value": "34",
			"name": "西藏"
		}, {
			"value": "12503",
			"name": "四川"
		}, {
			"value": "15600",
			"name": "重庆"
		}],
		"nameName": "上海",
		"toatl": "333880"
	}, {
		"item": [{
			"value": "625",
			"name": "北京"
		}, {
			"value": "4671",
			"name": "天津"
		}, {
			"value": "20246",
			"name": "河北"
		}, {
			"value": "4922",
			"name": "山西"
		}, {
			"value": "39985",
			"name": "河南"
		}, {
			"value": "79502",
			"name": "山东"
		}, {
			"value": "10673",
			"name": "上海"
		}, {
			"value": "-1",
			"name": "江苏"
		}, {
			"value": "35541",
			"name": "浙江"
		}, {
			"value": "6721",
			"name": "福建"
		}, {
			"value": "85330",
			"name": "安徽"
		}, {
			"value": "11883",
			"name": "江西"
		}, {
			"value": "26407",
			"name": "湖北"
		}, {
			"value": "20370",
			"name": "湖南"
		}, {
			"value": "11392",
			"name": "广东"
		}, {
			"value": "11604",
			"name": "广西"
		}, {
			"value": "4784",
			"name": "贵州"
		}, {
			"value": "7138",
			"name": "云南"
		}, {
			"value": "558",
			"name": "海南"
		}, {
			"value": "2419",
			"name": "黑龙江"
		}, {
			"value": "2584",
			"name": "吉林"
		}, {
			"value": "12016",
			"name": "辽宁"
		}, {
			"value": "20310",
			"name": "陕西"
		}, {
			"value": "15297",
			"name": "新疆"
		}, {
			"value": "8160",
			"name": "内蒙古"
		}, {
			"value": "5277",
			"name": "青海"
		}, {
			"value": "10446",
			"name": "宁夏"
		}, {
			"value": "19374",
			"name": "甘肃"
		}, {
			"value": "712",
			"name": "西藏"
		}, {
			"value": "21058",
			"name": "四川"
		}, {
			"value": "11938",
			"name": "重庆"
		}],
		"nameName": "江苏",
		"toatl": "511943"
	}, {
		"item": [{
			"value": "79",
			"name": "北京"
		}, {
			"value": "393",
			"name": "天津"
		}, {
			"value": "5657",
			"name": "河北"
		}, {
			"value": "1423",
			"name": "山西"
		}, {
			"value": "5780",
			"name": "河南"
		}, {
			"value": "5640",
			"name": "山东"
		}, {
			"value": "4893",
			"name": "上海"
		}, {
			"value": "16662",
			"name": "江苏"
		}, {
			"value": "-1",
			"name": "浙江"
		}, {
			"value": "3535",
			"name": "福建"
		}, {
			"value": "8381",
			"name": "安徽"
		}, {
			"value": "4033",
			"name": "江西"
		}, {
			"value": "6986",
			"name": "湖北"
		}, {
			"value": "8111",
			"name": "湖南"
		}, {
			"value": "7675",
			"name": "广东"
		}, {
			"value": "4681",
			"name": "广西"
		}, {
			"value": "2329",
			"name": "贵州"
		}, {
			"value": "3060",
			"name": "云南"
		}, {
			"value": "108",
			"name": "海南"
		}, {
			"value": "1744",
			"name": "黑龙江"
		}, {
			"value": "2713",
			"name": "吉林"
		}, {
			"value": "13918",
			"name": "辽宁"
		}, {
			"value": "5001",
			"name": "陕西"
		}, {
			"value": "4060",
			"name": "新疆"
		}, {
			"value": "698",
			"name": "内蒙古"
		}, {
			"value": "231",
			"name": "青海"
		}, {
			"value": "1341",
			"name": "宁夏"
		}, {
			"value": "4567",
			"name": "甘肃"
		}, {
			"value": "13",
			"name": "西藏"
		}, {
			"value": "4892",
			"name": "四川"
		}, {
			"value": "5963",
			"name": "重庆"
		}],
		"nameName": "浙江",
		"toatl": "134567"
	}, {
		"item": [{
			"value": "25",
			"name": "北京"
		}, {
			"value": "67",
			"name": "天津"
		}, {
			"value": "616",
			"name": "河北"
		}, {
			"value": "138",
			"name": "山西"
		}, {
			"value": "439",
			"name": "河南"
		}, {
			"value": "715",
			"name": "山东"
		}, {
			"value": "63",
			"name": "上海"
		}, {
			"value": "839",
			"name": "江苏"
		}, {
			"value": "1926",
			"name": "浙江"
		}, {
			"value": "-1",
			"name": "福建"
		}, {
			"value": "456",
			"name": "安徽"
		}, {
			"value": "1254",
			"name": "江西"
		}, {
			"value": "966",
			"name": "湖北"
		}, {
			"value": "1420",
			"name": "湖南"
		}, {
			"value": "7312",
			"name": "广东"
		}, {
			"value": "821",
			"name": "广西"
		}, {
			"value": "409",
			"name": "贵州"
		}, {
			"value": "590",
			"name": "云南"
		}, {
			"value": "37",
			"name": "海南"
		}, {
			"value": "68",
			"name": "黑龙江"
		}, {
			"value": "97",
			"name": "吉林"
		}, {
			"value": "785",
			"name": "辽宁"
		}, {
			"value": "366",
			"name": "陕西"
		}, {
			"value": "542",
			"name": "新疆"
		}, {
			"value": "132",
			"name": "内蒙古"
		}, {
			"value": "29",
			"name": "青海"
		}, {
			"value": "104",
			"name": "宁夏"
		}, {
			"value": "454",
			"name": "甘肃"
		}, {
			"value": "4",
			"name": "西藏"
		}, {
			"value": "646",
			"name": "四川"
		}, {
			"value": "819",
			"name": "重庆"
		}],
		"nameName": "福建",
		"toatl": "22139"
	}, {
		"item": [{
			"value": "977",
			"name": "北京"
		}, {
			"value": "3271",
			"name": "天津"
		}, {
			"value": "20901",
			"name": "河北"
		}, {
			"value": "5799",
			"name": "山西"
		}, {
			"value": "91433",
			"name": "河南"
		}, {
			"value": "30319",
			"name": "山东"
		}, {
			"value": "8243",
			"name": "上海"
		}, {
			"value": "97004",
			"name": "江苏"
		}, {
			"value": "69851",
			"name": "浙江"
		}, {
			"value": "14810",
			"name": "福建"
		}, {
			"value": "-1",
			"name": "安徽"
		}, {
			"value": "35166",
			"name": "江西"
		}, {
			"value": "53008",
			"name": "湖北"
		}, {
			"value": "36077",
			"name": "湖南"
		}, {
			"value": "48750",
			"name": "广东"
		}, {
			"value": "22322",
			"name": "广西"
		}, {
			"value": "7007",
			"name": "贵州"
		}, {
			"value": "14970",
			"name": "云南"
		}, {
			"value": "1479",
			"name": "海南"
		}, {
			"value": "1528",
			"name": "黑龙江"
		}, {
			"value": "2220",
			"name": "吉林"
		}, {
			"value": "9283",
			"name": "辽宁"
		}, {
			"value": "30853",
			"name": "陕西"
		}, {
			"value": "35889",
			"name": "新疆"
		}, {
			"value": "5647",
			"name": "内蒙古"
		}, {
			"value": "7547",
			"name": "青海"
		}, {
			"value": "10708",
			"name": "宁夏"
		}, {
			"value": "31078",
			"name": "甘肃"
		}, {
			"value": "654",
			"name": "西藏"
		}, {
			"value": "39828",
			"name": "四川"
		}, {
			"value": "18072",
			"name": "重庆"
		}],
		"nameName": "安徽",
		"toatl": "754694"
	}, {
		"item": [{
			"value": "235",
			"name": "北京"
		}, {
			"value": "832",
			"name": "天津"
		}, {
			"value": "6268",
			"name": "河北"
		}, {
			"value": "749",
			"name": "山西"
		}, {
			"value": "9281",
			"name": "河南"
		}, {
			"value": "3665",
			"name": "山东"
		}, {
			"value": "1050",
			"name": "上海"
		}, {
			"value": "7371",
			"name": "江苏"
		}, {
			"value": "14609",
			"name": "浙江"
		}, {
			"value": "29439",
			"name": "福建"
		}, {
			"value": "8903",
			"name": "安徽"
		}, {
			"value": "-1",
			"name": "江西"
		}, {
			"value": "19851",
			"name": "湖北"
		}, {
			"value": "69702",
			"name": "湖南"
		}, {
			"value": "120046",
			"name": "广东"
		}, {
			"value": "31858",
			"name": "广西"
		}, {
			"value": "12436",
			"name": "贵州"
		}, {
			"value": "19535",
			"name": "云南"
		}, {
			"value": "8302",
			"name": "海南"
		}, {
			"value": "1282",
			"name": "黑龙江"
		}, {
			"value": "2029",
			"name": "吉林"
		}, {
			"value": "3702",
			"name": "辽宁"
		}, {
			"value": "11832",
			"name": "陕西"
		}, {
			"value": "7609",
			"name": "新疆"
		}, {
			"value": "3133",
			"name": "内蒙古"
		}, {
			"value": "14629",
			"name": "青海"
		}, {
			"value": "5978",
			"name": "宁夏"
		}, {
			"value": "24137",
			"name": "甘肃"
		}, {
			"value": "2157",
			"name": "西藏"
		}, {
			"value": "21850",
			"name": "四川"
		}, {
			"value": "8683",
			"name": "重庆"
		}],
		"nameName": "江西",
		"toatl": "471153"
	}, {
		"item": [{
			"value": "166",
			"name": "北京"
		}, {
			"value": "303",
			"name": "天津"
		}, {
			"value": "6449",
			"name": "河北"
		}, {
			"value": "1035",
			"name": "山西"
		}, {
			"value": "24820",
			"name": "河南"
		}, {
			"value": "2520",
			"name": "山东"
		}, {
			"value": "509",
			"name": "上海"
		}, {
			"value": "1939",
			"name": "江苏"
		}, {
			"value": "4031",
			"name": "浙江"
		}, {
			"value": "9521",
			"name": "福建"
		}, {
			"value": "3810",
			"name": "安徽"
		}, {
			"value": "7740",
			"name": "江西"
		}, {
			"value": "-1",
			"name": "湖北"
		}, {
			"value": "48072",
			"name": "湖南"
		}, {
			"value": "44037",
			"name": "广东"
		}, {
			"value": "14257",
			"name": "广西"
		}, {
			"value": "6431",
			"name": "贵州"
		}, {
			"value": "6202",
			"name": "云南"
		}, {
			"value": "641",
			"name": "海南"
		}, {
			"value": "427",
			"name": "黑龙江"
		}, {
			"value": "962",
			"name": "吉林"
		}, {
			"value": "3691",
			"name": "辽宁"
		}, {
			"value": "25132",
			"name": "陕西"
		}, {
			"value": "9628",
			"name": "新疆"
		}, {
			"value": "1778",
			"name": "内蒙古"
		}, {
			"value": "2410",
			"name": "青海"
		}, {
			"value": "9091",
			"name": "宁夏"
		}, {
			"value": "16193",
			"name": "甘肃"
		}, {
			"value": "929",
			"name": "西藏"
		}, {
			"value": "20611",
			"name": "四川"
		}, {
			"value": "17997",
			"name": "重庆"
		}],
		"nameName": "湖北",
		"toatl": "291332"
	}, {
		"item": [{
			"value": "40",
			"name": "北京"
		}, {
			"value": "108",
			"name": "天津"
		}, {
			"value": "1596",
			"name": "河北"
		}, {
			"value": "549",
			"name": "山西"
		}, {
			"value": "1498",
			"name": "河南"
		}, {
			"value": "472",
			"name": "山东"
		}, {
			"value": "63",
			"name": "上海"
		}, {
			"value": "545",
			"name": "江苏"
		}, {
			"value": "583",
			"name": "浙江"
		}, {
			"value": "782",
			"name": "福建"
		}, {
			"value": "597",
			"name": "安徽"
		}, {
			"value": "5287",
			"name": "江西"
		}, {
			"value": "8127",
			"name": "湖北"
		}, {
			"value": "-1",
			"name": "湖南"
		}, {
			"value": "44210",
			"name": "广东"
		}, {
			"value": "12741",
			"name": "广西"
		}, {
			"value": "6337",
			"name": "贵州"
		}, {
			"value": "3824",
			"name": "云南"
		}, {
			"value": "493",
			"name": "海南"
		}, {
			"value": "93",
			"name": "黑龙江"
		}, {
			"value": "248",
			"name": "吉林"
		}, {
			"value": "1444",
			"name": "辽宁"
		}, {
			"value": "2246",
			"name": "陕西"
		}, {
			"value": "767",
			"name": "新疆"
		}, {
			"value": "161",
			"name": "内蒙古"
		}, {
			"value": "218",
			"name": "青海"
		}, {
			"value": "735",
			"name": "宁夏"
		}, {
			"value": "1581",
			"name": "甘肃"
		}, {
			"value": "115",
			"name": "西藏"
		}, {
			"value": "2197",
			"name": "四川"
		}, {
			"value": "2772",
			"name": "重庆"
		}],
		"nameName": "湖南",
		"toatl": "100429"
	}, {
		"item": [{
			"value": "367",
			"name": "北京"
		}, {
			"value": "332",
			"name": "天津"
		}, {
			"value": "3983",
			"name": "河北"
		}, {
			"value": "596",
			"name": "山西"
		}, {
			"value": "6110",
			"name": "河南"
		}, {
			"value": "1972",
			"name": "山东"
		}, {
			"value": "430",
			"name": "上海"
		}, {
			"value": "2432",
			"name": "江苏"
		}, {
			"value": "1231",
			"name": "浙江"
		}, {
			"value": "3268",
			"name": "福建"
		}, {
			"value": "1373",
			"name": "安徽"
		}, {
			"value": "2563",
			"name": "江西"
		}, {
			"value": "7888",
			"name": "湖北"
		}, {
			"value": "18318",
			"name": "湖南"
		}, {
			"value": "-1",
			"name": "广东"
		}, {
			"value": "27036",
			"name": "广西"
		}, {
			"value": "2200",
			"name": "贵州"
		}, {
			"value": "4552",
			"name": "云南"
		}, {
			"value": "1436",
			"name": "海南"
		}, {
			"value": "227",
			"name": "黑龙江"
		}, {
			"value": "329",
			"name": "吉林"
		}, {
			"value": "2576",
			"name": "辽宁"
		}, {
			"value": "4035",
			"name": "陕西"
		}, {
			"value": "1970",
			"name": "新疆"
		}, {
			"value": "390",
			"name": "内蒙古"
		}, {
			"value": "118",
			"name": "青海"
		}, {
			"value": "1518",
			"name": "宁夏"
		}, {
			"value": "3886",
			"name": "甘肃"
		}, {
			"value": "22",
			"name": "西藏"
		}, {
			"value": "7344",
			"name": "四川"
		}, {
			"value": "10338",
			"name": "重庆"
		}],
		"nameName": "广东",
		"toatl": "118840"
	}, {
		"item": [{
			"value": "54",
			"name": "北京"
		}, {
			"value": "68",
			"name": "天津"
		}, {
			"value": "1013",
			"name": "河北"
		}, {
			"value": "124",
			"name": "山西"
		}, {
			"value": "1571",
			"name": "河南"
		}, {
			"value": "1281",
			"name": "山东"
		}, {
			"value": "20",
			"name": "上海"
		}, {
			"value": "247",
			"name": "江苏"
		}, {
			"value": "148",
			"name": "浙江"
		}, {
			"value": "812",
			"name": "福建"
		}, {
			"value": "135",
			"name": "安徽"
		}, {
			"value": "727",
			"name": "江西"
		}, {
			"value": "1980",
			"name": "湖北"
		}, {
			"value": "6406",
			"name": "湖南"
		}, {
			"value": "98397",
			"name": "广东"
		}, {
			"value": "-1",
			"name": "广西"
		}, {
			"value": "7761",
			"name": "贵州"
		}, {
			"value": "22771",
			"name": "云南"
		}, {
			"value": "1891",
			"name": "海南"
		}, {
			"value": "31",
			"name": "黑龙江"
		}, {
			"value": "58",
			"name": "吉林"
		}, {
			"value": "214",
			"name": "辽宁"
		}, {
			"value": "2775",
			"name": "陕西"
		}, {
			"value": "1424",
			"name": "新疆"
		}, {
			"value": "114",
			"name": "内蒙古"
		}, {
			"value": "658",
			"name": "青海"
		}, {
			"value": "361",
			"name": "宁夏"
		}, {
			"value": "1168",
			"name": "甘肃"
		}, {
			"value": "67",
			"name": "西藏"
		}, {
			"value": "4314",
			"name": "四川"
		}, {
			"value": "2221",
			"name": "重庆"
		}],
		"nameName": "广西",
		"toatl": "158811"
	}, {
		"item": [{
			"value": "2",
			"name": "北京"
		}, {
			"value": "2",
			"name": "天津"
		}, {
			"value": "129",
			"name": "河北"
		}, {
			"value": "13",
			"name": "山西"
		}, {
			"value": "110",
			"name": "河南"
		}, {
			"value": "48",
			"name": "山东"
		}, {
			"value": "5",
			"name": "上海"
		}, {
			"value": "17",
			"name": "江苏"
		}, {
			"value": "109",
			"name": "浙江"
		}, {
			"value": "34",
			"name": "福建"
		}, {
			"value": "11",
			"name": "安徽"
		}, {
			"value": "20",
			"name": "江西"
		}, {
			"value": "142",
			"name": "湖北"
		}, {
			"value": "2763",
			"name": "湖南"
		}, {
			"value": "595",
			"name": "广东"
		}, {
			"value": "2808",
			"name": "广西"
		}, {
			"value": "-1",
			"name": "贵州"
		}, {
			"value": "3600",
			"name": "云南"
		}, {
			"value": "11",
			"name": "海南"
		}, {
			"value": "5",
			"name": "黑龙江"
		}, {
			"value": "19",
			"name": "吉林"
		}, {
			"value": "61",
			"name": "辽宁"
		}, {
			"value": "229",
			"name": "陕西"
		}, {
			"value": "97",
			"name": "新疆"
		}, {
			"value": "28",
			"name": "内蒙古"
		}, {
			"value": "32",
			"name": "青海"
		}, {
			"value": "23",
			"name": "宁夏"
		}, {
			"value": "228",
			"name": "甘肃"
		}, {
			"value": "36",
			"name": "西藏"
		}, {
			"value": "1586",
			"name": "四川"
		}, {
			"value": "3376",
			"name": "重庆"
		}],
		"nameName": "贵州",
		"toatl": "16139"
	}, {
		"item": [{
			"value": "9",
			"name": "北京"
		}, {
			"value": "51",
			"name": "天津"
		}, {
			"value": "1396",
			"name": "河北"
		}, {
			"value": "96",
			"name": "山西"
		}, {
			"value": "658",
			"name": "河南"
		}, {
			"value": "118",
			"name": "山东"
		}, {
			"value": "10",
			"name": "上海"
		}, {
			"value": "66",
			"name": "江苏"
		}, {
			"value": "63",
			"name": "浙江"
		}, {
			"value": "52",
			"name": "福建"
		}, {
			"value": "68",
			"name": "安徽"
		}, {
			"value": "89",
			"name": "江西"
		}, {
			"value": "381",
			"name": "湖北"
		}, {
			"value": "2550",
			"name": "湖南"
		}, {
			"value": "1206",
			"name": "广东"
		}, {
			"value": "13761",
			"name": "广西"
		}, {
			"value": "4521",
			"name": "贵州"
		}, {
			"value": "-1",
			"name": "云南"
		}, {
			"value": "47",
			"name": "海南"
		}, {
			"value": "212",
			"name": "黑龙江"
		}, {
			"value": "231",
			"name": "吉林"
		}, {
			"value": "1139",
			"name": "辽宁"
		}, {
			"value": "795",
			"name": "陕西"
		}, {
			"value": "293",
			"name": "新疆"
		}, {
			"value": "728",
			"name": "内蒙古"
		}, {
			"value": "204",
			"name": "青海"
		}, {
			"value": "118",
			"name": "宁夏"
		}, {
			"value": "935",
			"name": "甘肃"
		}, {
			"value": "844",
			"name": "西藏"
		}, {
			"value": "10785",
			"name": "四川"
		}, {
			"value": "647",
			"name": "重庆"
		}],
		"nameName": "云南",
		"toatl": "42073"
	}, {
		"item": [{
			"value": "0",
			"name": "北京"
		}, {
			"value": "0",
			"name": "天津"
		}, {
			"value": "64",
			"name": "河北"
		}, {
			"value": "3",
			"name": "山西"
		}, {
			"value": "12",
			"name": "河南"
		}, {
			"value": "47",
			"name": "山东"
		}, {
			"value": "0",
			"name": "上海"
		}, {
			"value": "16",
			"name": "江苏"
		}, {
			"value": "14",
			"name": "浙江"
		}, {
			"value": "9",
			"name": "福建"
		}, {
			"value": "14",
			"name": "安徽"
		}, {
			"value": "29",
			"name": "江西"
		}, {
			"value": "30",
			"name": "湖北"
		}, {
			"value": "53",
			"name": "湖南"
		}, {
			"value": "1803",
			"name": "广东"
		}, {
			"value": "71",
			"name": "广西"
		}, {
			"value": "8",
			"name": "贵州"
		}, {
			"value": "0",
			"name": "云南"
		}, {
			"value": "-1",
			"name": "海南"
		}, {
			"value": "4",
			"name": "黑龙江"
		}, {
			"value": "2",
			"name": "吉林"
		}, {
			"value": "2",
			"name": "辽宁"
		}, {
			"value": "7",
			"name": "陕西"
		}, {
			"value": "20",
			"name": "新疆"
		}, {
			"value": "49",
			"name": "内蒙古"
		}, {
			"value": "4",
			"name": "青海"
		}, {
			"name": "宁夏"
		}, {
			"value": "11",
			"name": "甘肃"
		}, {
			"value": "9",
			"name": "西藏"
		}, {
			"value": "37",
			"name": "四川"
		}, {
			"value": "9",
			"name": "重庆"
		}],
		"nameName": "海南",
		"toatl": "2327"
	}, {
		"item": [{
			"value": "1050",
			"name": "北京"
		}, {
			"value": "14128",
			"name": "天津"
		}, {
			"value": "118234",
			"name": "河北"
		}, {
			"value": "6255",
			"name": "山西"
		}, {
			"value": "17253",
			"name": "河南"
		}, {
			"value": "47367",
			"name": "山东"
		}, {
			"value": "395",
			"name": "上海"
		}, {
			"value": "7302",
			"name": "江苏"
		}, {
			"value": "1675",
			"name": "浙江"
		}, {
			"value": "874",
			"name": "福建"
		}, {
			"value": "4579",
			"name": "安徽"
		}, {
			"value": "1305",
			"name": "江西"
		}, {
			"value": "7992",
			"name": "湖北"
		}, {
			"value": "6002",
			"name": "湖南"
		}, {
			"value": "2522",
			"name": "广东"
		}, {
			"value": "3467",
			"name": "广西"
		}, {
			"value": "988",
			"name": "贵州"
		}, {
			"value": "3089",
			"name": "云南"
		}, {
			"value": "266",
			"name": "海南"
		}, {
			"value": "-1",
			"name": "黑龙江"
		}, {
			"value": "231683",
			"name": "吉林"
		}, {
			"value": "328114",
			"name": "辽宁"
		}, {
			"value": "10025",
			"name": "陕西"
		}, {
			"value": "21713",
			"name": "新疆"
		}, {
			"value": "125045",
			"name": "内蒙古"
		}, {
			"value": "4392",
			"name": "青海"
		}, {
			"value": "4903",
			"name": "宁夏"
		}, {
			"value": "9556",
			"name": "甘肃"
		}, {
			"value": "809",
			"name": "西藏"
		}, {
			"value": "9119",
			"name": "四川"
		}, {
			"value": "1504",
			"name": "重庆"
		}],
		"nameName": "黑龙江",
		"toatl": "991606"
	}, {
		"item": [{
			"value": "1828",
			"name": "北京"
		}, {
			"value": "8556",
			"name": "天津"
		}, {
			"value": "130756",
			"name": "河北"
		}, {
			"value": "3893",
			"name": "山西"
		}, {
			"value": "26625",
			"name": "河南"
		}, {
			"value": "35918",
			"name": "山东"
		}, {
			"value": "560",
			"name": "上海"
		}, {
			"value": "5945",
			"name": "江苏"
		}, {
			"value": "1823",
			"name": "浙江"
		}, {
			"value": "1050",
			"name": "福建"
		}, {
			"value": "4212",
			"name": "安徽"
		}, {
			"value": "895",
			"name": "江西"
		}, {
			"value": "14196",
			"name": "湖北"
		}, {
			"value": "9566",
			"name": "湖南"
		}, {
			"value": "7033",
			"name": "广东"
		}, {
			"value": "4906",
			"name": "广西"
		}, {
			"value": "1517",
			"name": "贵州"
		}, {
			"value": "3093",
			"name": "云南"
		}, {
			"value": "207",
			"name": "海南"
		}, {
			"value": "37720",
			"name": "黑龙江"
		}, {
			"value": "-1",
			"name": "吉林"
		}, {
			"value": "251979",
			"name": "辽宁"
		}, {
			"value": "24176",
			"name": "陕西"
		}, {
			"value": "17374",
			"name": "新疆"
		}, {
			"value": "70105",
			"name": "内蒙古"
		}, {
			"value": "3212",
			"name": "青海"
		}, {
			"value": "5953",
			"name": "宁夏"
		}, {
			"value": "13469",
			"name": "甘肃"
		}, {
			"value": "380",
			"name": "西藏"
		}, {
			"value": "22497",
			"name": "四川"
		}, {
			"value": "4522",
			"name": "重庆"
		}],
		"nameName": "吉林",
		"toatl": "713966"
	}, {
		"item": [{
			"value": "2965",
			"name": "北京"
		}, {
			"value": "23904",
			"name": "天津"
		}, {
			"value": "366543",
			"name": "河北"
		}, {
			"value": "19555",
			"name": "山西"
		}, {
			"value": "50607",
			"name": "河南"
		}, {
			"value": "84757",
			"name": "山东"
		}, {
			"value": "1358",
			"name": "上海"
		}, {
			"value": "37930",
			"name": "江苏"
		}, {
			"value": "4378",
			"name": "浙江"
		}, {
			"value": "3425",
			"name": "福建"
		}, {
			"value": "10489",
			"name": "安徽"
		}, {
			"value": "3215",
			"name": "江西"
		}, {
			"value": "19241",
			"name": "湖北"
		}, {
			"value": "16463",
			"name": "湖南"
		}, {
			"value": "5751",
			"name": "广东"
		}, {
			"value": "10156",
			"name": "广西"
		}, {
			"value": "3102",
			"name": "贵州"
		}, {
			"value": "9151",
			"name": "云南"
		}, {
			"value": "1915",
			"name": "海南"
		}, {
			"value": "96269",
			"name": "黑龙江"
		}, {
			"value": "223690",
			"name": "吉林"
		}, {
			"value": "-1",
			"name": "辽宁"
		}, {
			"value": "28567",
			"name": "陕西"
		}, {
			"value": "39434",
			"name": "新疆"
		}, {
			"value": "167067",
			"name": "内蒙古"
		}, {
			"value": "5965",
			"name": "青海"
		}, {
			"value": "10590",
			"name": "宁夏"
		}, {
			"value": "20715",
			"name": "甘肃"
		}, {
			"value": "726",
			"name": "西藏"
		}, {
			"value": "29552",
			"name": "四川"
		}, {
			"value": "4790",
			"name": "重庆"
		}],
		"nameName": "辽宁",
		"toatl": "1302270"
	}, {
		"item": [{
			"value": "75",
			"name": "北京"
		}, {
			"value": "183",
			"name": "天津"
		}, {
			"value": "3136",
			"name": "河北"
		}, {
			"value": "25391",
			"name": "山西"
		}, {
			"value": "24662",
			"name": "河南"
		}, {
			"value": "2081",
			"name": "山东"
		}, {
			"value": "142",
			"name": "上海"
		}, {
			"value": "950",
			"name": "江苏"
		}, {
			"value": "669",
			"name": "浙江"
		}, {
			"value": "1057",
			"name": "福建"
		}, {
			"value": "1088",
			"name": "安徽"
		}, {
			"value": "684",
			"name": "江西"
		}, {
			"value": "19069",
			"name": "湖北"
		}, {
			"value": "9958",
			"name": "湖南"
		}, {
			"value": "3073",
			"name": "广东"
		}, {
			"value": "3723",
			"name": "广西"
		}, {
			"value": "2940",
			"name": "贵州"
		}, {
			"value": "9666",
			"name": "云南"
		}, {
			"value": "211",
			"name": "海南"
		}, {
			"value": "296",
			"name": "黑龙江"
		}, {
			"value": "169",
			"name": "吉林"
		}, {
			"value": "1533",
			"name": "辽宁"
		}, {
			"value": "-1",
			"name": "陕西"
		}, {
			"value": "25685",
			"name": "新疆"
		}, {
			"value": "41492",
			"name": "内蒙古"
		}, {
			"value": "15339",
			"name": "青海"
		}, {
			"value": "53686",
			"name": "宁夏"
		}, {
			"value": "119205",
			"name": "甘肃"
		}, {
			"value": "1772",
			"name": "西藏"
		}, {
			"value": "134391",
			"name": "四川"
		}, {
			"value": "12446",
			"name": "重庆"
		}],
		"nameName": "陕西",
		"toatl": "514772"
	}, {
		"item": [{
			"value": "10",
			"name": "北京"
		}, {
			"value": "10",
			"name": "天津"
		}, {
			"value": "143",
			"name": "河北"
		}, {
			"value": "87",
			"name": "山西"
		}, {
			"value": "434",
			"name": "河南"
		}, {
			"value": "123",
			"name": "山东"
		}, {
			"value": "8",
			"name": "上海"
		}, {
			"value": "55",
			"name": "江苏"
		}, {
			"value": "91",
			"name": "浙江"
		}, {
			"value": "14",
			"name": "福建"
		}, {
			"value": "54",
			"name": "安徽"
		}, {
			"value": "8",
			"name": "江西"
		}, {
			"value": "378",
			"name": "湖北"
		}, {
			"value": "97",
			"name": "湖南"
		}, {
			"value": "35",
			"name": "广东"
		}, {
			"value": "31",
			"name": "广西"
		}, {
			"value": "9",
			"name": "贵州"
		}, {
			"value": "15",
			"name": "云南"
		}, {
			"value": "0",
			"name": "海南"
		}, {
			"value": "10",
			"name": "黑龙江"
		}, {
			"value": "52",
			"name": "吉林"
		}, {
			"value": "33",
			"name": "辽宁"
		}, {
			"value": "1923",
			"name": "陕西"
		}, {
			"value": "-1",
			"name": "新疆"
		}, {
			"value": "471",
			"name": "内蒙古"
		}, {
			"value": "2989",
			"name": "青海"
		}, {
			"value": "1140",
			"name": "宁夏"
		}, {
			"value": "13930",
			"name": "甘肃"
		}, {
			"value": "136",
			"name": "西藏"
		}, {
			"value": "894",
			"name": "四川"
		}, {
			"value": "99",
			"name": "重庆"
		}],
		"nameName": "新疆",
		"toatl": "23279"
	}, {
		"item": [{
			"value": "1076",
			"name": "北京"
		}, {
			"value": "3423",
			"name": "天津"
		}, {
			"value": "55872",
			"name": "河北"
		}, {
			"value": "11659",
			"name": "山西"
		}, {
			"value": "4257",
			"name": "河南"
		}, {
			"value": "7929",
			"name": "山东"
		}, {
			"value": "130",
			"name": "上海"
		}, {
			"value": "1590",
			"name": "江苏"
		}, {
			"value": "317",
			"name": "浙江"
		}, {
			"value": "132",
			"name": "福建"
		}, {
			"value": "1458",
			"name": "安徽"
		}, {
			"value": "160",
			"name": "江西"
		}, {
			"value": "1799",
			"name": "湖北"
		}, {
			"value": "934",
			"name": "湖南"
		}, {
			"value": "293",
			"name": "广东"
		}, {
			"value": "581",
			"name": "广西"
		}, {
			"value": "199",
			"name": "贵州"
		}, {
			"value": "709",
			"name": "云南"
		}, {
			"value": "17",
			"name": "海南"
		}, {
			"value": "6175",
			"name": "黑龙江"
		}, {
			"value": "15443",
			"name": "吉林"
		}, {
			"value": "47649",
			"name": "辽宁"
		}, {
			"value": "11955",
			"name": "陕西"
		}, {
			"value": "10344",
			"name": "新疆"
		}, {
			"value": "-1",
			"name": "内蒙古"
		}, {
			"value": "2677",
			"name": "青海"
		}, {
			"value": "20721",
			"name": "宁夏"
		}, {
			"value": "14965",
			"name": "甘肃"
		}, {
			"value": "271",
			"name": "西藏"
		}, {
			"value": "7394",
			"name": "四川"
		}, {
			"value": "910",
			"name": "重庆"
		}],
		"nameName": "内蒙古",
		"toatl": "231039"
	}, {
		"item": [{
			"value": "1",
			"name": "北京"
		}, {
			"value": "2",
			"name": "天津"
		}, {
			"value": "76",
			"name": "河北"
		}, {
			"value": "18",
			"name": "山西"
		}, {
			"value": "193",
			"name": "河南"
		}, {
			"value": "63",
			"name": "山东"
		}, {
			"value": "8",
			"name": "上海"
		}, {
			"value": "36",
			"name": "江苏"
		}, {
			"value": "39",
			"name": "浙江"
		}, {
			"value": "3",
			"name": "福建"
		}, {
			"value": "22",
			"name": "安徽"
		}, {
			"value": "17",
			"name": "江西"
		}, {
			"value": "36",
			"name": "湖北"
		}, {
			"value": "39",
			"name": "湖南"
		}, {
			"value": "15",
			"name": "广东"
		}, {
			"value": "23",
			"name": "广西"
		}, {
			"value": "21",
			"name": "贵州"
		}, {
			"value": "335",
			"name": "云南"
		}, {
			"value": "1",
			"name": "海南"
		}, {
			"value": "53",
			"name": "黑龙江"
		}, {
			"value": "1",
			"name": "吉林"
		}, {
			"value": "33",
			"name": "辽宁"
		}, {
			"value": "849",
			"name": "陕西"
		}, {
			"value": "3703",
			"name": "新疆"
		}, {
			"value": "398",
			"name": "内蒙古"
		}, {
			"value": "-1",
			"name": "青海"
		}, {
			"value": "989",
			"name": "宁夏"
		}, {
			"value": "25628",
			"name": "甘肃"
		}, {
			"value": "8589",
			"name": "西藏"
		}, {
			"value": "6172",
			"name": "四川"
		}, {
			"value": "176",
			"name": "重庆"
		}],
		"nameName": "青海",
		"toatl": "47539"
	}, {
		"item": [{
			"value": "83",
			"name": "北京"
		}, {
			"value": "530",
			"name": "天津"
		}, {
			"value": "2970",
			"name": "河北"
		}, {
			"value": "1166",
			"name": "山西"
		}, {
			"value": "14080",
			"name": "河南"
		}, {
			"value": "781",
			"name": "山东"
		}, {
			"value": "139",
			"name": "上海"
		}, {
			"value": "658",
			"name": "江苏"
		}, {
			"value": "1941",
			"name": "浙江"
		}, {
			"value": "335",
			"name": "福建"
		}, {
			"value": "4466",
			"name": "安徽"
		}, {
			"value": "605",
			"name": "江西"
		}, {
			"value": "16643",
			"name": "湖北"
		}, {
			"value": "5281",
			"name": "湖南"
		}, {
			"value": "1332",
			"name": "广东"
		}, {
			"value": "2776",
			"name": "广西"
		}, {
			"value": "601",
			"name": "贵州"
		}, {
			"value": "5558",
			"name": "云南"
		}, {
			"value": "25",
			"name": "海南"
		}, {
			"value": "23",
			"name": "黑龙江"
		}, {
			"value": "64",
			"name": "吉林"
		}, {
			"value": "124",
			"name": "辽宁"
		}, {
			"value": "75095",
			"name": "陕西"
		}, {
			"value": "38528",
			"name": "新疆"
		}, {
			"value": "51519",
			"name": "内蒙古"
		}, {
			"value": "32994",
			"name": "青海"
		}, {
			"value": "-1",
			"name": "宁夏"
		}, {
			"value": "129427",
			"name": "甘肃"
		}, {
			"value": "3160",
			"name": "西藏"
		}, {
			"value": "38722",
			"name": "四川"
		}, {
			"value": "2965",
			"name": "重庆"
		}],
		"nameName": "宁夏",
		"toatl": "432591"
	}, {
		"item": [{
			"value": "32",
			"name": "北京"
		}, {
			"value": "69",
			"name": "天津"
		}, {
			"value": "1518",
			"name": "河北"
		}, {
			"value": "391",
			"name": "山西"
		}, {
			"value": "3887",
			"name": "河南"
		}, {
			"value": "292",
			"name": "山东"
		}, {
			"value": "33",
			"name": "上海"
		}, {
			"value": "228",
			"name": "江苏"
		}, {
			"value": "690",
			"name": "浙江"
		}, {
			"value": "164",
			"name": "福建"
		}, {
			"value": "615",
			"name": "安徽"
		}, {
			"value": "99",
			"name": "江西"
		}, {
			"value": "3618",
			"name": "湖北"
		}, {
			"value": "1686",
			"name": "湖南"
		}, {
			"value": "462",
			"name": "广东"
		}, {
			"value": "642",
			"name": "广西"
		}, {
			"value": "447",
			"name": "贵州"
		}, {
			"value": "1851",
			"name": "云南"
		}, {
			"value": "34",
			"name": "海南"
		}, {
			"value": "32",
			"name": "黑龙江"
		}, {
			"value": "31",
			"name": "吉林"
		}, {
			"value": "142",
			"name": "辽宁"
		}, {
			"value": "53261",
			"name": "陕西"
		}, {
			"value": "34250",
			"name": "新疆"
		}, {
			"value": "9583",
			"name": "内蒙古"
		}, {
			"value": "32101",
			"name": "青海"
		}, {
			"value": "45806",
			"name": "宁夏"
		}, {
			"value": "-1",
			"name": "甘肃"
		}, {
			"value": "3511",
			"name": "西藏"
		}, {
			"value": "37264",
			"name": "四川"
		}, {
			"value": "2227",
			"name": "重庆"
		}],
		"nameName": "甘肃",
		"toatl": "234966"
	}, {
		"item": [{
			"value": "0",
			"name": "北京"
		}, {
			"value": "0",
			"name": "天津"
		}, {
			"value": "0",
			"name": "河北"
		}, {
			"value": "0",
			"name": "山西"
		}, {
			"value": "6",
			"name": "河南"
		}, {
			"value": "1",
			"name": "山东"
		}, {
			"value": "0",
			"name": "上海"
		}, {
			"value": "0",
			"name": "江苏"
		}, {
			"value": "0",
			"name": "浙江"
		}, {
			"value": "0",
			"name": "福建"
		}, {
			"value": "0",
			"name": "安徽"
		}, {
			"value": "0",
			"name": "江西"
		}, {
			"value": "0",
			"name": "湖北"
		}, {
			"value": "0",
			"name": "湖南"
		}, {
			"value": "0",
			"name": "广东"
		}, {
			"value": "0",
			"name": "广西"
		}, {
			"value": "0",
			"name": "贵州"
		}, {
			"value": "0",
			"name": "云南"
		}, {
			"value": "0",
			"name": "海南"
		}, {
			"value": "0",
			"name": "黑龙江"
		}, {
			"value": "0",
			"name": "吉林"
		}, {
			"value": "0",
			"name": "辽宁"
		}, {
			"value": "2",
			"name": "陕西"
		}, {
			"value": "1",
			"name": "新疆"
		}, {
			"value": "0",
			"name": "内蒙古"
		}, {
			"value": "127",
			"name": "青海"
		}, {
			"value": "2",
			"name": "宁夏"
		}, {
			"value": "3",
			"name": "甘肃"
		}, {
			"value": "-1",
			"name": "西藏"
		}, {
			"value": "52",
			"name": "四川"
		}, {
			"value": "0",
			"name": "重庆"
		}],
		"nameName": "西藏",
		"toatl": "194"
	}, {
		"item": [{
			"value": "62",
			"name": "北京"
		}, {
			"value": "258",
			"name": "天津"
		}, {
			"value": "3515",
			"name": "河北"
		}, {
			"value": "343",
			"name": "山西"
		}, {
			"value": "4556",
			"name": "河南"
		}, {
			"value": "563",
			"name": "山东"
		}, {
			"value": "443",
			"name": "上海"
		}, {
			"value": "841",
			"name": "江苏"
		}, {
			"value": "1451",
			"name": "浙江"
		}, {
			"value": "1452",
			"name": "福建"
		}, {
			"value": "710",
			"name": "安徽"
		}, {
			"value": "1211",
			"name": "江西"
		}, {
			"value": "9385",
			"name": "湖北"
		}, {
			"value": "10795",
			"name": "湖南"
		}, {
			"value": "11723",
			"name": "广东"
		}, {
			"value": "26410",
			"name": "广西"
		}, {
			"value": "26565",
			"name": "贵州"
		}, {
			"value": "100935",
			"name": "云南"
		}, {
			"value": "507",
			"name": "海南"
		}, {
			"value": "224",
			"name": "黑龙江"
		}, {
			"value": "429",
			"name": "吉林"
		}, {
			"value": "1607",
			"name": "辽宁"
		}, {
			"value": "30262",
			"name": "陕西"
		}, {
			"value": "15633",
			"name": "新疆"
		}, {
			"value": "820",
			"name": "内蒙古"
		}, {
			"value": "13961",
			"name": "青海"
		}, {
			"value": "1626",
			"name": "宁夏"
		}, {
			"value": "24573",
			"name": "甘肃"
		}, {
			"value": "10187",
			"name": "西藏"
		}, {
			"value": "-1",
			"name": "四川"
		}, {
			"value": "120570",
			"name": "重庆"
		}],
		"nameName": "四川",
		"toatl": "421617"
	}, {
		"item": [{
			"value": "90",
			"name": "北京"
		}, {
			"value": "1273",
			"name": "天津"
		}, {
			"value": "7347",
			"name": "河北"
		}, {
			"value": "277",
			"name": "山西"
		}, {
			"value": "5375",
			"name": "河南"
		}, {
			"value": "1516",
			"name": "山东"
		}, {
			"value": "603",
			"name": "上海"
		}, {
			"value": "1206",
			"name": "江苏"
		}, {
			"value": "1678",
			"name": "浙江"
		}, {
			"value": "4851",
			"name": "福建"
		}, {
			"value": "501",
			"name": "安徽"
		}, {
			"value": "1745",
			"name": "江西"
		}, {
			"value": "23427",
			"name": "湖北"
		}, {
			"value": "40152",
			"name": "湖南"
		}, {
			"value": "14132",
			"name": "广东"
		}, {
			"value": "18137",
			"name": "广西"
		}, {
			"value": "75688",
			"name": "贵州"
		}, {
			"value": "47141",
			"name": "云南"
		}, {
			"value": "580",
			"name": "海南"
		}, {
			"value": "287",
			"name": "黑龙江"
		}, {
			"value": "944",
			"name": "吉林"
		}, {
			"value": "1371",
			"name": "辽宁"
		}, {
			"value": "15772",
			"name": "陕西"
		}, {
			"value": "29076",
			"name": "新疆"
		}, {
			"value": "1448",
			"name": "内蒙古"
		}, {
			"value": "3819",
			"name": "青海"
		}, {
			"value": "991",
			"name": "宁夏"
		}, {
			"value": "10387",
			"name": "甘肃"
		}, {
			"value": "2211",
			"name": "西藏"
		}, {
			"value": "260342",
			"name": "四川"
		}, {
			"value": "-1",
			"name": "重庆"
		}],
		"nameName": "重庆",
		"toatl": "572367"
	}]
}